export const hasKey = (
// eslint-disable-next-line @typescript-eslint/ban-types
rec, key) => 
// eslint-disable-next-line no-restricted-globals
Object.hasOwn(rec, key);
